import { CommandController } from './../../../commanding/CommandController';


import { BasicController } from "../BasicController";
import { BasicSoundController } from "../BasicSoundController";
import { SimpleCommand } from './../../../commanding/SimpleCommand';

export class BasicInitalizeControllerCommand extends SimpleCommand {
    public /*final*/ execute(commandVars: any = null): void {
        CommandController.instance.executeCommand(BasicController.COMMAND_INIT_SERVERCOMMANDS);

        this.initializeGameControllers();
    }

    /**
     * Use this hook to initialize game specific controller logic
     */
    protected initializeGameControllers(): void {
        // override
    }

    public /*final*/ initSoundController(soundController: BasicSoundController): void {
        BasicController.getInstance().soundController = soundController;
        BasicController.getInstance().soundController.initialize();
    }
}
